import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./legal.css";

const LegalPage = ({ title, lastUpdated, children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-page">
      <header className="legal-topbar">
        <div className="legal-container legal-topbar-inner">
          <Link to="/" className="legal-brand">
            <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M16 3C9.373 3 4 8.373 4 15c0 5.018 3.08 9.317 7.45 11.116C12.346 27.316 14.063 28 16 28c1.937 0 3.654-.684 4.55-1.884C24.92 24.317 28 20.018 28 15c0-6.627-5.373-12-12-12z" stroke="currentColor" strokeWidth="2" fill="none" />
              <circle cx="16" cy="15" r="2.5" fill="currentColor" />
            </svg>
            <span>clubsagent.ai</span>
          </Link>
          <Link to="/" className="legal-back">← Volver al inicio</Link>
        </div>
      </header>

      <main className="legal-container legal-content">
        <h1>{title}</h1>
        {lastUpdated && <p className="legal-updated">Última actualización: {lastUpdated}</p>}
        {children}
        <nav className="legal-footer-links">
          <Link to="/aviso-legal">Aviso Legal</Link>
          <Link to="/privacidad">Política de Privacidad</Link>
          <Link to="/cookies">Política de Cookies</Link>
          <Link to="/terminos">Términos y Condiciones</Link>
        </nav>
      </main>
    </div>
  );
};

export default LegalPage;
